import MetricBase from "models/metrics/MetricBase";
import VisibilityGroup from "models/groups/VisibilityGroup";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";

class MetricAvgDay2Arrival extends MetricBase {
    constructor() {
        super({
            field: "metric_abs_top_impr_share_tripadvisor",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.absTopImprShareTripadvisor.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.absTopImprShareTripadvisor.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.absTopImprShareTripadvisor.tooltip"),
            group: new VisibilityGroup(),
        });
    }
}

export default MetricAvgDay2Arrival;
